<template>
    <el-dialog title="问卷" :visible.sync="showModal" width="824px" :close-on-click-modal="false">
        <h3 class="questionnaire-title">问卷标题: {{ questionnaireTitle }}</h3>
        <div class="question-container">
            <div class="question-item" v-for="(item, index) in questionnaireTemplate" :key="index">
                <el-tag style="padding: 0 5px;" class="question-title">{{ item.name }} ({{
                    item.type === 1 ? '单选' : item.type === 2 ? '多选' : item.type === 3 ? '问答' :
                        item.type === 4 ? '附件' : '其它'
                }})</el-tag>
                <p v-if="item.type === 1 || item.type === 3" style="font-size: 1rem; margin-left: 2em;">{{
                    questionnaireContent[index + 1] }}</p>
                <div v-else-if="item.type === 2" style="margin: 16px 0; margin-left: 2em;">
                    <span style="font-size: 1rem;" v-for="(option, optionIndex) in questionnaireContent[index + 1]"
                        :key="optionIndex">
                        {{ option }}{{ questionnaireContent[index + 1].length !== optionIndex + 1 ? ',' : '' }}
                    </span>
                </div>
                <div v-else-if="item.type === 4">
                    <button class="download-but" style="vertical-align:middle; margin-right: 5px;"
                        @click="compressAndDownload(questionnaireContent[index + 1], detailData.order_id + '订单号的问卷附件')"><span>下载</span></button>
                </div>
            </div>
        </div>

    </el-dialog>
</template>

<script>
import { questionnaire } from "@/api/order"
import axios from 'axios'
import FileSaver from 'file-saver';
import JSZip from 'jszip';

export default {
    data: () => ({
        questionnaireTitle: '',
        questionnaireTemplate: {},
        questionnaireContent: {}
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        detailData: {
            default: null,
            type: null | String
        },

    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        async getTemplate(id) {
            const { data } = await questionnaire.questionnaireTemplate(id)
            this.questionnaireTitle = data.title
            this.questionnaireTemplate = data.template
            console.log(data);
        },
        getFile(url) {
            return new Promise((resolve, reject) => {
                console.log(url);
                axios(url, {
                    method: 'GET',
                    responseType: 'blob'
                }).then((res) => {
                    resolve(res)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        compressAndDownload(data, fileName) {
            const zip = new JSZip();
            const promises = [];  //用于存储多个promise

            this.$notify.info({
                title: '消息',
                message: '正在下载并打包附件...'
            });

            data.forEach((item) => {
                const promise = this.getFile(item.path).then((res) => {
                    const fileName = item.path
                    zip.file(fileName, res.data, { binary: true });
                })
                promises.push(promise)
            })

            Promise.all(promises).then(() => {
                zip.generateAsync({
                    type: "blob",
                    compression: "DEFLATE",  // STORE：默认不压缩 DEFLATE：需要压缩
                    compressionOptions: {
                        level: 1               // 压缩等级1~9    1压缩速度最快，9最优压缩方式
                    }
                }).then((res) => {
                    FileSaver.saveAs(res, fileName ? fileName : "压缩包.zip") // 利用file-saver保存文件
                })
            })
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
    },
    created() {
        this.getTemplate(this.detailData.questionnaire_id)
        const questionnaire_log = JSON.parse(this.detailData.questionnaire_log)
        this.questionnaireContent = questionnaire_log
        console.log(questionnaire_log);
    }
}
</script>

<style lang="scss" scoped>
.questionnaire-title {
    margin: 0;
    margin-bottom: 16px;
}

.question-item {
    margin: 30px 0;

    .question-title {
        width: auto;
        white-space: nowrap;
        padding: 0;
        margin: 0;
    }

    .download-but {
        display: inline-block;
        border-radius: 7px;
        border: none;
        background: #1875FF;
        color: white;
        font-family: inherit;
        text-align: center;
        font-size: 13px;
        box-shadow: 0px 14px 56px -11px #1875FF;
        width: 10em;
        padding: 1em;
        transition: all 0.4s;
        cursor: pointer;
        margin-top: 16px;
    }

    .download-but span {
        cursor: pointer;
        display: inline-block;
        position: relative;
        transition: 0.4s;
    }

    .download-but span:after {
        content: '附件';
        position: absolute;
        opacity: 0;
        top: 0;
        right: -20px;
        transition: 0.7s;
    }

    .download-but:hover span {
        padding-right: 2.1em;
    }

    .download-but:hover span:after {
        opacity: 4;
        right: 0;
    }
}
</style>